import { VariableType } from 'json-to-graphql-query';

export const AcceptVariables = {
  token: 'String!'
};

export const AcceptArgs = {
  token: new VariableType('token')
};
